import './Footer.css';

export default function Footer() {

    const year = new Date().getFullYear();

    return `
        <footer class="footer">

            <div class="footer__container">

               

                <div class="footer__line"></div>


                <div class="footer__bottom">

                    <div class="footer__copyright">
                        © ${year} PIEROGY
                    </div>

                    <div class="footer__university">
                       <a href="https://en.uj.edu.pl/en">Jagiellonian University <span class="about__link-arrow">&rarr;</span></a>
                        <span>·</span>
                        <a href="https://matinf.uj.edu.pl/en-GB/">Faculty of Mathematics and Computer Science <span class="about__link-arrow">&rarr;</span></a>
                    </div>

                </div>

            </div>

        </footer>
    `;

}
